import styled from 'styled-components';

import { EIconType } from '../Icon';

import { getIconColor } from '@/utils/fileIcon';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  border-radius: 8px;
  &:hover {
    background: ${({ theme }) => theme.colors.black1};
  }
  transition: all 0.3s ease;
`;

export const IconWrapper = styled.span<{ iconName?: EIconType }>`
  display: flex;
  padding: 9px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  max-width: 32px;
  background: ${({ theme, iconName }) => getIconColor(theme, iconName as EIconType)};
`;

export const DocName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;
